import type { Feed, FeedEntry, UIComponent } from '~/services/layout/index.ts';
import { getPluginConfig } from '~/utils/get-plugin-configuration.ts';
import manifest from '../config/manifest.ts';
import logger from '~/services/logger/index.ts';
import { twMerge } from 'tailwind-merge';

export default function WebviewComponent({
  uiComponent,
  feed,
}: {
  uiComponent: UIComponent;
  feed?: Feed;
}): JSX.Element {
  const config = getPluginConfig<typeof manifest>(manifest, uiComponent);

  const {
    general: { webview_accessibility_title, url },
    styles: { webview_height_type },
  } = config;

  try {
    const firstEntry: FeedEntry | undefined = feed?.entry?.[0];

    const src = firstEntry?.link?.href || url;

    if (!src) return <></>;

    return (
      <section
        className={twMerge(
          `component-${uiComponent.id} component-classes relative w-full overflow-hidden border-none`,
          !webview_height_type && 'h-webview',
          webview_height_type === 'custom' && 'h-webview',
          webview_height_type === 'screen_height' && 'h-screen'
        )}
      >
        <iframe
          title={webview_accessibility_title || 'iframe'}
          allowFullScreen={true}
          sandbox="allow-same-origin allow-scripts allow-forms allow-top-navigation"
          src={src}
          className="h-full w-full"
        />
      </section>
    );
  } catch (error: any) {
    logger.info(`Webview component: ${error.message}`);
    return <></>;
  }
}
